import { useState } from "react";
import "./index.css";

const DisclaimerModal = ({ handleDisclaimerAccept, handleDisclaimerCancel }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => setIsChecked(!isChecked);

  const handleAccept = () => {
    if (isChecked) {
      // Analytics.logEvent("accepted_disclaimer", {
      //   userId: 'email',
      // });
      handleDisclaimerAccept();
    } else {
      alert("Please accept the disclaimer to proceed.");
    }
  };

  return (
    <div className="disclaimerModal-overlay">
      <div className="disclaimerModal-container">
        <div className="disclaimerModal-header">
          <h2 className="disclaimerModal-title">GLUE ID Legal Disclaimer</h2>
        </div>

        <div className="disclaimerModal-body">
          <p className="disclaimerModal-instructions">
            By accessing data about legal entities from the GLUE ID database, you agree to the following terms and conditions:
          </p>

          <ol className="disclaimer-list">
            <li>
              <strong>Acceptance of Terms:</strong> Accessing or using the GLUE ID database constitutes your full acceptance of this disclaimer and agreement to be bound by its terms.
            </li>
            <li>
              <strong>No Warranty:</strong> The data provided in the GLUE ID database is offered “as is” without any warranties, express or implied.
            </li>
            <li>
              <strong>Limitation of Liability:</strong> GLUE ID and its Related Entities shall not be liable for any damages arising from your use of the GLUE ID database.
            </li>
            <li>
              <strong>Data Use at Your Own Risk:</strong> You acknowledge that your use of the GLUE ID database and any data obtained therefrom is at your sole risk.
            </li>
            <li>
              <strong>No Endorsement:</strong> Inclusion of data does not imply endorsement or validation by GLUE ID.
            </li>
            <li>
              <strong>Indemnification:</strong> You agree to indemnify and hold harmless GLUE ID and its Related Entities from any claims or damages.
            </li>
            <li>
              <strong>Governing Law:</strong> This disclaimer shall be governed by the laws of Delaware, USA.
            </li>
            <li>
              <strong>Changes to Disclaimer:</strong> GLUE ID reserves the right to modify this disclaimer at any time without prior notice.
            </li>
          </ol>

          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
              className="checkbox-icon"
            />
            <span className="checkbox-text">
              I have read, understood, and agree to the terms of this disclaimer.
            </span>
          </label>
        </div>

        <div className="disclaimerModal-footer">
          <button className="button-primary" onClick={handleAccept}>
            Accept & Continue
          </button>
          <button className="button-secondary" onClick={handleDisclaimerCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerModal;
